import { getJson } from "../helpers/request";
import { GeolocationData } from "../types/common";
import { LocationPromise } from "../types/location";

const LOCATION_URL = __LOCATION_API;

export const getCurrentGeolocation = async (): Promise<GeolocationData> => {
  const getLocation = async (): Promise<LocationPromise> => {
    try {
      return await getJson<LocationPromise>({ url: LOCATION_URL });
    } catch (e) {
      console.error("Locations API error: ", e);
      return { country_code: "FI", is_portability_region: true };
    }
  };

  const { country_code, is_portability_region } = await getLocation();

  return {
    countryCode: country_code ? country_code : "FI",
    isPortabilityRegion:
      is_portability_region !== undefined ? is_portability_region : true
  };
};
